import makeCrudMetaReducer from 'weego-common/src/utils/makeCrudMetaReducer';
import { actionTypes as accountsActionTypes } from '../../actions/accounts';

export default makeCrudMetaReducer(accountsActionTypes);
